import React from "react";
import {useSelector} from "react-redux";
import {
    GreetingContainer, GreetingImageContainer
} from './styles';
import {ReactComponent as GreetingImage} from '../../assets/images/greeting.svg';
import {useTranslation} from "react-i18next";
import {FlexColumn, FlexRow} from "../../components";
import {selectAdminUser} from "../../app/adminUser/selectors";

export const Greeting = () => {
    const admin = useSelector(selectAdminUser)
    const {t} = useTranslation()

    return <GreetingContainer>
            <FlexRow>
                <FlexColumn>
                    <h1>{t('hello_again')} {admin.first_name}!</h1>
                    <p>{t('welcome_to_dashboard')}</p>
                </FlexColumn>
                <GreetingImageContainer>
                    <GreetingImage/>
                </GreetingImageContainer>
            </FlexRow>
        </GreetingContainer>
}

export default Greeting
